import { key, domain } from "../Env";

const get = (url, qsp = {}, headers = {}) => {
    return new Promise(resolve => {
        // GENERATE API url
        const api = rqxto(url)

        // ASSIGN HEADERS
        let h = new Headers();
        Object.keys(headers).map(k => h.append(k, headers[k]));
        if (api.rqx_type !== 'custom') {
            h.append('Content-Type', 'application/json');
            h.append('x-api-key', api.rqx_type === 'global' ? key('gapi_key') : api.rqx_type === 'biz' ? key('bizapi_key') : api.rqx_type === 's3' ? key('s3api_key') : api.rqx_type === 'shp' ? key('shpapi_key') : key('tapi_key'));
        }

        // SET REQUEST
        let subqsp = []
        Object.keys(qsp).map(k => subqsp.push(`${k}=${qsp[k]}`));
        qsp = `${subqsp.join('&')}`

        // SET PARAMETERS
        let params = {
            method: 'GET',
            headers: h,
            redirect: 'follow'
        };

        // SEND REQUEST
        fetch(`${api.url}?${qsp}`, params).then(result => {
            return resolve(result.json())
        }).catch(error => console.log('error', error));
    })
}

const post = (url, body = {}, headers = {}) => {
    return new Promise(resolve => {
        // GENERATE API url
        const api = rqxto(url)

        // ASSIGN HEADERS
        let h = new Headers();
        Object.keys(headers).map(k => h.append(k, headers[k]));
        if (api.rqx_type !== 'custom') {
            h.append('Content-Type', 'application/json');
            h.append('x-api-key', api.rqx_type === 'global' ? key('gapi_key') : api.rqx_type === 'biz' ? key('bizapi_key') : api.rqx_type === 's3' ? key('s3api_key') : api.rqx_type === 'shp' ? key('shpapi_key') : key('tapi_key'));
        }

        // SET PARAMETERS
        let params = {
            method: 'POST',
            headers: h,
            body: JSON.stringify(body),
            redirect: 'follow'
        };

        // SEND REQUEST
        fetch(`${api.url}`, params).then(result => {
            return resolve(result.json())
        }).catch(error => console.log('error', error));
    })
}

const fbGraph = (endpoint, accessToken, params = {}) => {
    return new Promise(resolve => {
        // GENERATE API url
        const api = rqxto(`<<fb>>/${endpoint}`)

        // ASSIGN HEADERS
        let h = new Headers();
        h.append('Content-Type', 'application/json');

        // SET REQUEST
        let subqsp = []
        params.access_token = accessToken
        Object.keys(params).map(k => subqsp.push(`${k}=${params[k]}`));
        const qsp = `${subqsp.join('&')}`

        // SET PARAMETERS
        let requestParams = {
            method: 'GET',
            headers: h,
            redirect: 'follow'
        };

        // SEND REQUEST
        const url = api.url.includes('?') ? `${api.url}&${qsp}` : `${api.url}?${qsp}`;
        fetch(url, requestParams).then(result => {
            return resolve(result.json())
        }).catch(error => console.log('error', error));
    })
}

const lgGraph = (endpoint, accessToken, params = {}) => {
    return new Promise(resolve => {
        // GENERATE API url
        const api = rqxto(`<<lg>>/${endpoint}`)

        // ASSIGN HEADERS
        let h = new Headers();
        h.append('Content-Type', 'application/json');

        // SET REQUEST
        let subqsp = []
        params.access_token = accessToken
        Object.keys(params).map(k => subqsp.push(`${k}=${params[k]}`));
        const qsp = `${subqsp.join('&')}`

        // SET PARAMETERS
        let requestParams = {
            method: 'GET',
            headers: h,
            redirect: 'follow'
        };

        // SEND REQUEST
        const url = api.url.includes('?') ? `${api.url}&${qsp}` : `${api.url}?${qsp}`;
        fetch(url, requestParams).then(result => {
            return resolve(result.json())
        }).catch(error => console.log('error', error));
    })
}

const linkedInGraph = (endpoint, accessToken, params = {}) => {
    return new Promise(resolve => {
        // GENERATE API url
        const api = rqxto(`<<li>>/${endpoint}`)

        // ASSIGN HEADERS
        let h = new Headers();
        h.append('Content-Type', 'application/json');
        h.append('X-Restli-Protocol-Version', '2.0.0');
        h.append('Authorization', `Bearer ${accessToken}`);

        // URL encode parameter values for proper encoding of special characters (e.g., : in URNs)
        let subqsp = []
        Object.keys(params).map(k => {
            const encodedValue = encodeURIComponent(params[k]);
            subqsp.push(`${k}=${encodedValue}`);
        });
        const qsp = subqsp.length > 0 ? `${subqsp.join('&')}` : '';

        // SET PARAMETERS
        let requestParams = {
            method: 'GET',
            headers: h,
            redirect: 'follow'
        };

        // SEND REQUEST
        const url = qsp ? (api.url.includes('?') ? `${api.url}&${qsp}` : `${api.url}?${qsp}`) : api.url;
        fetch(url, requestParams).then(result => {
            return resolve(result.json())
        }).catch(error => console.log('error', error));
    })
}

const rqxto = (url) => {
    let type = 'custom'
    let d = url
    let subdir = ''
    if (url.includes('<<')) {
        url.split('<<').map(v => {
            if (v.includes('>>')) {
                type = v.split('>>').shift()
                if (type === 'fb') {
                    d = 'https://graph.facebook.com/v24.0'
                } else if (type === 'lg') {
                    d = 'https://graph.instagram.com/v22.0'
                } else if (type === 'li') {
                    d = 'https://api.linkedin.com/v2'
                } else {
                    d = domain('api')[v.split('>>').shift()]
                }
                subdir = v.split('>>').pop()
            }

            return v
        })
    }

    return {
        rqx_type: type,
        url: `${d}${subdir}`
    }
}

export const rqx = { get, post, fbGraph, lgGraph, linkedInGraph }